// @generated by protobuf-ts 2.11.1 with parameter long_type_string,generate_dependencies,output_legacy_commonjs
// @generated from protobuf file "sennotech/base/organization/permission.proto" (package "base.organization", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { StringValue } from "../../google/protobuf/wrappers";
/**
 * @generated from protobuf message base.organization.ListPermissionResponse
 */
export interface ListPermissionResponse {
    /**
     * @generated from protobuf field: repeated base.organization.Permission permissions = 1
     */
    permissions: Permission[];
}
/**
 * @generated from protobuf message base.organization.ListPermissionRequest
 */
export interface ListPermissionRequest {
}
/**
 * @generated from protobuf message base.organization.RegisterPermissionResponse
 */
export interface RegisterPermissionResponse {
}
/**
 * @generated from protobuf message base.organization.RegisterPermissionRequest
 */
export interface RegisterPermissionRequest {
    /**
     * @generated from protobuf field: repeated base.organization.Permission permissions = 1
     */
    permissions: Permission[];
}
/**
 * @generated from protobuf message base.organization.Permission
 */
export interface Permission {
    /**
     * @generated from protobuf field: google.protobuf.StringValue uuid = 1
     */
    uuid?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue module = 2
     */
    module?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue function = 3
     */
    function?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue description = 4
     */
    description?: StringValue;
}
// @generated message type with reflection information, may provide speed optimized methods
class ListPermissionResponse$Type extends MessageType<ListPermissionResponse> {
    constructor() {
        super("base.organization.ListPermissionResponse", [
            { no: 1, name: "permissions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Permission }
        ]);
    }
    create(value?: PartialMessage<ListPermissionResponse>): ListPermissionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.permissions = [];
        if (value !== undefined)
            reflectionMergePartial<ListPermissionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListPermissionResponse): ListPermissionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.organization.Permission permissions */ 1:
                    message.permissions.push(Permission.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListPermissionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.organization.Permission permissions = 1; */
        for (let i = 0; i < message.permissions.length; i++)
            Permission.internalBinaryWrite(message.permissions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.ListPermissionResponse
 */
export const ListPermissionResponse = new ListPermissionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPermissionRequest$Type extends MessageType<ListPermissionRequest> {
    constructor() {
        super("base.organization.ListPermissionRequest", []);
    }
    create(value?: PartialMessage<ListPermissionRequest>): ListPermissionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListPermissionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListPermissionRequest): ListPermissionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListPermissionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.ListPermissionRequest
 */
export const ListPermissionRequest = new ListPermissionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterPermissionResponse$Type extends MessageType<RegisterPermissionResponse> {
    constructor() {
        super("base.organization.RegisterPermissionResponse", []);
    }
    create(value?: PartialMessage<RegisterPermissionResponse>): RegisterPermissionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RegisterPermissionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RegisterPermissionResponse): RegisterPermissionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RegisterPermissionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.RegisterPermissionResponse
 */
export const RegisterPermissionResponse = new RegisterPermissionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterPermissionRequest$Type extends MessageType<RegisterPermissionRequest> {
    constructor() {
        super("base.organization.RegisterPermissionRequest", [
            { no: 1, name: "permissions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Permission }
        ]);
    }
    create(value?: PartialMessage<RegisterPermissionRequest>): RegisterPermissionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.permissions = [];
        if (value !== undefined)
            reflectionMergePartial<RegisterPermissionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RegisterPermissionRequest): RegisterPermissionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.organization.Permission permissions */ 1:
                    message.permissions.push(Permission.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RegisterPermissionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.organization.Permission permissions = 1; */
        for (let i = 0; i < message.permissions.length; i++)
            Permission.internalBinaryWrite(message.permissions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.RegisterPermissionRequest
 */
export const RegisterPermissionRequest = new RegisterPermissionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Permission$Type extends MessageType<Permission> {
    constructor() {
        super("base.organization.Permission", [
            { no: 1, name: "uuid", kind: "message", T: () => StringValue },
            { no: 2, name: "module", kind: "message", T: () => StringValue },
            { no: 3, name: "function", kind: "message", T: () => StringValue },
            { no: 4, name: "description", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<Permission>): Permission {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Permission>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Permission): Permission {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.StringValue uuid */ 1:
                    message.uuid = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.uuid);
                    break;
                case /* google.protobuf.StringValue module */ 2:
                    message.module = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.module);
                    break;
                case /* google.protobuf.StringValue function */ 3:
                    message.function = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.function);
                    break;
                case /* google.protobuf.StringValue description */ 4:
                    message.description = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.description);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Permission, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.StringValue uuid = 1; */
        if (message.uuid)
            StringValue.internalBinaryWrite(message.uuid, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue module = 2; */
        if (message.module)
            StringValue.internalBinaryWrite(message.module, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue function = 3; */
        if (message.function)
            StringValue.internalBinaryWrite(message.function, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue description = 4; */
        if (message.description)
            StringValue.internalBinaryWrite(message.description, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.Permission
 */
export const Permission = new Permission$Type();
/**
 * @generated ServiceType for protobuf service base.organization.PermissionService
 */
export const PermissionService = new ServiceType("base.organization.PermissionService", [
    { name: "RegisterPermission", options: { "google.api.http": { post: "/base.organization.PermissionService/RegisterPermission", body: "*" } }, I: RegisterPermissionRequest, O: RegisterPermissionResponse },
    { name: "ListPermission", options: { "google.api.http": { post: "/base.organization.PermissionService/ListPermission", body: "*" } }, I: ListPermissionRequest, O: ListPermissionResponse }
]);
